import React, {Component} from "react"

class PageBody extends Component {
  render() {
    return (
      <div className="wrapper wrapper-content animated fadeInRight">
        {this.props.children}
      </div>
    )
  }
}

export default PageBody



// WEBPACK FOOTER //
// ./src/components/PageBody.js